import { useQuery } from '@tanstack/react-query';

import { fetchEditors } from '../services/api/editors';

import type { EditorResponse } from '../types';

export const useEditors = () => {
  return useQuery({
    queryKey: ['editors'],
    queryFn: fetchEditors,
    initialData: [] as EditorResponse[],
  });
};
